export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  responseType: process.env.REACT_APP_AUTH0_RESPONSE_TYPE,
  scope: process.env.REACT_APP_AUTH0_SCOPE
};



// WEBPACK FOOTER //
// ./src/environment.js